import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth-service/auth-service.service';
import { TabIdentifier } from '@core/services/tab-identifier/tab-identifier.service';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private authkey: string | null = null;
  private giverId: string | null = null;
  private receiverId: string | null = null;
  private isExternalUser: boolean = false;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private tabIdentifierService: TabIdentifier,
    private authService: AuthService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const csrf = this.cookieService.get('csrftoken');

    // Skip token for login and token refresh endpoints
    if (req.url.includes('/login')) {
      return next.handle(req);
    }

    // Add JWT token to request
    const token = this.authService.getAccessToken();
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // Check if the current route is an external discussion
    const currentUrl = window.location.pathname;
    if (currentUrl.includes('/exam_open_access/')) {
      this.isExternalUser = true;
    }

    if (this.isExternalUser) {
      // Extract exam_request_id from the URL
      const urlParts = currentUrl.split('/');
      let examRequestId = urlParts[urlParts.indexOf('exam_open_access') + 1];
      if (examRequestId === 'standalone_viewer') {
        examRequestId = urlParts[urlParts.indexOf('exam_open_access') + 2];
      }
      // Get query parameters
      const queryParams = new URLSearchParams(window.location.search);
      let authkey = queryParams.get('auth_key');
      let giverId = queryParams.get('giver_id');
      let receiverId = queryParams.get('receiver_id');

      if (authkey) {
        this.authkey = authkey;
      } else {
        authkey = this.authkey;
      }

      if (giverId) {
        this.giverId = giverId;
      } else {
        giverId = this.giverId;
      }

      if (receiverId) {
        this.receiverId = receiverId;
      } else {
        receiverId = this.receiverId;
      }
      const params: any = {
        ...(examRequestId && { exam_request_id: examRequestId }),
        ...(authkey && { auth_key: authkey }),
        ...(giverId && { giver_id: giverId }),
      };

      if (receiverId) {
        params.receiver_id = receiverId;
      }

      req = req.clone({
        setParams: params,
      });
    }

    if (csrf && ['POST', 'PATCH', 'PUT', 'DELETE'].includes(req.method)) {
      req = req.clone({
        withCredentials: true,
        headers: req.headers
          .set('X-CSRFToken', csrf)
          .set('TabIdentifier', this.tabIdentifierService.tabIdentifier),
      });
    } else {
      req = req.clone({
        withCredentials: true,
      });
    }
    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            console.log('CATCHED ERROR, STATUS', err.status);
            if (!this.router.url.includes('auth')) {
              localStorage.setItem('latestUrl', this.router.url);
            }
            this.router.navigate(['auth/login']);
          }
          return throwError(() => err);
        }
        return throwError(() => err);
      }),
      finalize(() => {}),
    );
  }
}
